/**
 * Manages all animation for a given object. Animation gets added to an object by
 * create an Incrementer and Timeline for each driven property
 */
import { Animation } from "./animation";
var VERBOSE = false;
var AnimationStack = /** @class */ (function () {
    function AnimationStack(parent) {
        this._time = 0;
        this._parent = undefined;
        this._animations = [];
        this._parent = parent;
    }
    Object.defineProperty(AnimationStack.prototype, "animations", {
        get: function () {
            return this._animations;
        },
        enumerable: false,
        configurable: true
    });
    // NOTE: is it possible to animate a text property (container.x, y)
    AnimationStack.prototype.addAnimation = function (deformer, property) {
        if (!property) {
            throw new Error('property is required');
        }
        VERBOSE && console.log('add animation', deformer, property);
        // TODO: ensure the property exists on the deformer
        var animation = new Animation(deformer, property);
        this._animations.push(animation);
        return animation;
    };
    AnimationStack.prototype.getAnimation = function (deformer, property) {
        return this._animations.find(function (animation) { return animation.target === deformer && animation.property === property; });
    };
    AnimationStack.prototype.removeAnimation = function (deformer, property) {
        var animation = this.getAnimation(deformer, property);
        if (animation) {
            this._animations.splice(this._animations.indexOf(animation), 1);
        }
    };
    Object.defineProperty(AnimationStack.prototype, "dirty", {
        /**
         * The animation stack is dirty if any of its animations have unprocessed changes. Incrementer or timeline changes
         * are two examples of changes that need to be processed. In other words, the objects need to be (re)built.
         */
        get: function () {
            return this._animations.some(function (animation) { return animation.dirty; });
        },
        enumerable: false,
        configurable: true
    });
    AnimationStack.prototype.update = function () {
        VERBOSE && console.log('animationStack update');
        this.animations.forEach(function (animation) { return animation.update(); });
    };
    Object.defineProperty(AnimationStack.prototype, "time", {
        get: function () {
            return this._time;
        },
        /**
         * Set the time for all animations in the stack. Setting the time for an animation will force the object to be
         * evaluated. This involves the evaluation of the incrementer and timeline which, in turn, sets the resulting value
         * to the target object's driven property.
         * @param value
         */
        set: function (value) {
            this._time = value;
            this.animations.forEach(function (animation) { return animation.time = value; });
        },
        enumerable: false,
        configurable: true
    });
    return AnimationStack;
}());
export { AnimationStack };
